import { Chess, swapColor, } from "@chesshotel/chess";
import { pieceValues, exchangeEvaluation, uci2move, move2uci, } from "../util.js";
import { detectOpponentMateThreat } from "../mateThreat.js";
import { detectLeaveUndefended } from "../sacrifice.js";
export function isValidMove(chess, move) {
    const possibleMoves = chess.uciMoves({ square: move.from });
    return possibleMoves.includes(move2uci(move));
}
export function isValidFenMove(fen, moveStr) {
    const chess = new Chess(fen);
    const move = uci2move(moveStr);
    const possibleMoves = chess.uciMoves({ square: move.from });
    return possibleMoves.includes(moveStr);
}
export function checkDefenceLossDiscoveredAttack(fen, moveStr, minGainThreshold) {
    const isOpponentMateThreat = detectOpponentMateThreat(fen, moveStr);
    if (isOpponentMateThreat) {
        return true;
    }
    const isLeaveUndefended = detectLeaveUndefended(fen, moveStr);
    let lostGain = 0;
    if (isLeaveUndefended) {
        lostGain = pieceValues[isLeaveUndefended.mainPiece.type];
        return lostGain > minGainThreshold;
    }
    return false;
}
export function checkDefenceLossFork(fen, moveStr, minGainThreshold) {
    const isOpponentMateThreat = detectOpponentMateThreat(fen, moveStr);
    if (isOpponentMateThreat) {
        return true;
    }
    return false;
}
export function checkDefendable(fen, captures, onlyFromCapturedPieces = true) {
    const chess = new Chess(fen);
    const opponentColor = chess.turn();
    const color = swapColor(opponentColor);
    const opponentMoves = chess.uciMoves({ verbose: true, legal: true });
    let isDefendable = false;
    let replyMove = null;
    for (const reply of opponentMoves) {
        replyMove = uci2move(reply);
        if (onlyFromCapturedPieces) {
            const isFromThreat = captures.some((c) => c.to === replyMove.from);
            if (!isFromThreat) {
                continue;
            }
        }
        const temp = new Chess(fen);
        const replyGain = exchangeEvaluation(temp.fen(), replyMove.to, {
            from: replyMove.from,
            filteredByLoss: true,
        }).gain;
        if (replyGain < 0) {
            continue;
        }
        temp.move(replyMove);
        const goodCaptures = captures
            .map((capture) => {
            const valid = isValidMove(temp, capture);
            if (!valid) {
                return 0;
            }
            const evaluation = exchangeEvaluation(temp.fen(), capture.to, {
                from: capture.from,
            });
            return evaluation.gain;
        })
            .filter((gain) => {
            return gain > 0;
        });
        if (goodCaptures.length == 0) {
            isDefendable = true;
            break;
        }
    }
    return { isDefendable, replyMove };
}
//# sourceMappingURL=util.js.map